
import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/attestation/${ view }.vue`);
}

const Index = loadView( 'Index' );

const attestationRoutes = [
    {
        path: 'attestation',
        name: 'api.attestation.resource.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'attestation/:id',
        name: 'api.attestation.resource.get',
        component: Index,
        meta: {
            middleware: permission
        }
    },
];

export default attestationRoutes;
